import GeneralService from "../services/general-service";
import useFetch from "./useFetch";
import useShortCode from "./useShortCode";

const noop = async () => {};

async function getPlans({ moduleName }) {
  const plans = await GeneralService.getAllPlans({ moduleName });

  return plans;
}

function useFetchAllPlans(options = {}) {
  const shortCode = useShortCode();
  const { moduleName, ...fetchOptions } = options;
  const input = shortCode
    ? { shortCode, moduleName: moduleName || null }
    : null;

  return useFetch(shortCode ? getPlans : noop, input, {
    cacheTime: 12 * 60 * 60,
    ...fetchOptions,
  });
}

export default useFetchAllPlans;
